<template>
  <div class="reactive-rover-card">
    <va-card title="Reactive Rover">
      <reactive-rover-classes />
      <h2 class="curriculum">
        Class curriculum
      </h2>
      <span class="class-description">
        In this 6 week class, you will learn how to teach your dog skills to better handle the unexpected world around them.
        Your dog will learn hand targeting, find it, look at that, leave it, loose leash walking, gotcha!,
        choosing distance, and more!
      </span>
      <va-accordion>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 1 - The Foundations
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 1 we will cover:
              <ol>
                <li>Introducing the marker</li>
                <li>Eye contact</li>
                <li>Name game</li>
                <li>Hand targeting</li>
                <li>Stuff-a-dog</li>
                <li>Dog body language</li>
              </ol>
            </div>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 2 - Handler techniques for attention outside
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 2 we will cover:
              <ol>
                <li>Adding "Focus" cue to eye contact</li>
                <li>Find it</li>
                <li>Leash handling techniques</li>
                <li>Hand target with distance</li>
                <li>U-turns</li>
              </ol>
            </div>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 3 - Working where your dog can think
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 3 we will cover:
              <ol>
                <li>Gotcha! game to safely grab your dog</li>
                <li>Look at That</li>
                <li>Thresholds</li>
                <li>Choosing distance</li>
                <li>Mat work</li>
                <li>Relaxation Protocol</li>
              </ol>
            </div>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 4 - Shortening the distance
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 4 we will cover:
              <ol>
                <li>Advanced Look at That</li>
                <li>Safely prevent other dogs from approaching</li>
                <li>Advanced Choosing Distance</li>
                <li>Loose leash walking</li>
              </ol>
            </div>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 5 - High levels of distractions
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 5 we will cover:
              <ol>
                <li>Leave it</li>
                <li>Difficulty levels of seeing other dogs</li>
                <li>Advanced loose leash walking</li>
              </ol>
            </div>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Week 6 - Putting it all together
            </va-button>
          </span>
          <div slot="body" class="week-description">
            <div>
              In Week 6 we will cover:
              <ol>
                <li>Student questions</li>
                <li>Enrichment</li>
                <li>Putting it all together</li>
                <li>Say hi! for a polite greeting</li>
                <li>Graduation!</li>
              </ol>
            </div>
          </div>
        </va-collapse>
      </va-accordion>
      <contact-group-class />
      <router-link :to="{name: 'all-group-classes'}" class="all-group-classes">
        <va-button>
          View all group classes
        </va-button>
      </router-link>
    </va-card>
  </div>
</template>

<script>
import ReactiveRoverClasses from '../sub-components/ReactiveRoverClasses'
import ContactGroupClass from '../sub-components/ContactGroupClass'

export default {
  name: 'reactive-rover-card',
  components: {
    ReactiveRoverClasses,
    ContactGroupClass,
  },
}
</script>

<style scoped lang="scss">
.reactive-rover-card {
  .va-card__body {
    display: flex;
    flex-direction: column;
    align-items: center;

    .class-description {
      text-align: left;
      margin: 1rem;
    }

    .va-button {
      border-radius: 0.375rem;
      max-width: 90%;
      width: 90%;
      margin-left: 1rem;

      &__content {
        font-size: 1.3rem;
        font-family: Montserrat, sans-serif;

        &__title {
          font-size: 1.3rem;
        }
      }
    }

    .all-group-classes {
      display: flex;
      justify-content: center;
      margin-top: 1rem;

      .va-button {
        border-radius: 0.375rem;
        max-width: 90%;
        width: 90%;
        margin-left: 1rem;

        @include media-breakpoint-up(lg) {
          width: 50%;
        }

        &__content {
          font-size: 1.3rem;
          font-family: Montserrat, sans-serif;

          &__title {
            font-size: 1.3rem;
          }
        }
      }
    }

    .week-description {
      div {
        margin-top: 1rem;
      }

      ol {
        margin-left: 2rem;

        li {
          list-style: decimal;
        }
      }
    }

    span {
      margin-top: 1rem;
      text-align: center;
    }
  }

  .curriculum,
  .va-accordion {
    width: 100%;
  }
}
</style>
